/**
 * waitingRoomTeamView — Blue/Red columns + move buttons for waiting room.
 */

function rowHtml(p, { canMove }) {
  const name = p.displayName || p.clientId || '?';
  const champ = p.championId || '—';
  const tag = p.isBot ? 'bot' : 'jugador';
  const lock = p.locked ? 'listo' : 'eligiendo';
  const id = p.clientId || '';
  const team = p.team === 'chaos' ? 'chaos' : 'order';
  const moveBtns = canMove
    ? (
      `<button type="button" class="mb-team-btn" data-set-team="order" data-client-id="${id}">→ Blue</button>` +
      `<button type="button" class="mb-team-btn" data-set-team="chaos" data-client-id="${id}">→ Red</button>`
    )
    : '';
  return (
    `<div class="mb-wait-row" data-locked="${Boolean(p.locked)}" data-team="${team}" data-client-id="${id}">` +
    `<span class="mb-wait-name">${name}</span>` +
    `<span class="mb-wait-champ">${champ}</span>` +
    `<span class="mb-wait-tag">${tag}</span>` +
    `<span class="mb-wait-lock">${lock}</span>` +
    (moveBtns ? `<span class="mb-wait-moves">${moveBtns}</span>` : '') +
    `</div>`
  );
}

function columnHtml(title, team, players, opts) {
  const { localClientId, isHost } = opts;
  const rows = players.map((p) => rowHtml(p, {
    canMove: Boolean(isHost || (localClientId && p.clientId === localClientId))
  })).join('');
  return (
    `<div class="mb-team-col" data-team="${team}">` +
    `<h3 class="mb-team-title">${title}</h3>` +
    (rows || '<p class="mb-empty">Vacío</p>') +
    `</div>`
  );
}

/**
 * @param {object} room
 * @param {{ localClientId?: string, isHost?: boolean }} [opts]
 */
export function renderWaitingPlayersHtml(room, opts = {}) {
  const players = room?.players || [];
  if (!players.length) {
    return '<p class="mb-empty">Nadie en la sala.</p>';
  }
  const order = players.filter((p) => p.team !== 'chaos');
  const chaos = players.filter((p) => p.team === 'chaos');
  return (
    `<div class="mb-team-board">` +
    columnHtml('Blue (Order)', 'order', order, opts) +
    columnHtml('Red (Chaos)', 'chaos', chaos, opts) +
    `</div>`
  );
}
